// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb {
    padding: 10px 50px;
    font-size: 14px;
    border-bottom: 1px solid #a7c898;
    margin-top: 119px;
}

.breadcrumb ul {
    list-style: none;
    padding-top: 15px;
    margin: 0;
    display: flex;
    color: #636363;
}

.breadcrumb li {
    margin-right: 5px;
    color: #636363;
    display: flex;
    align-items: center;
}

.breadcrumb li a {
    text-decoration: none;
    color: #636363;
}

.breadcrumb li a:hover {
    color: #4a7c59;
    text-decoration: underline;
}

.breadcrumb li::after {
    content: '>';
    margin-left: 5px;
    font-size: 12px;
    color: #a0a0a0; /* 흐린 색 */
}

.breadcrumb li:last-child::after {
    content: '';
}

.breadcrumb-item.active {
    background: none !important;
    border: none !important;
    padding: 0;
    font-weight: bold; /* 마지막 요소 강조 */
    color: #4a7c59; /* 마지막 요소 색상 변경 (선택 사항) */
}

@media screen and (max-width: 768px) {
    .breadcrumb {
        padding: 10px 20px;
        font-size: 12px;
    }

    .breadcrumb li::after {
        margin-left: 5px;
        font-size: 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc,EAAE,SAAS;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,UAAU;IACV,iBAAiB,EAAE,cAAc;IACjC,cAAc,EAAE,yBAAyB;AAC7C;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;AACJ","sourcesContent":[".breadcrumb {\n    padding: 10px 50px;\n    font-size: 14px;\n    border-bottom: 1px solid #a7c898;\n    margin-top: 119px;\n}\n\n.breadcrumb ul {\n    list-style: none;\n    padding-top: 15px;\n    margin: 0;\n    display: flex;\n    color: #636363;\n}\n\n.breadcrumb li {\n    margin-right: 5px;\n    color: #636363;\n    display: flex;\n    align-items: center;\n}\n\n.breadcrumb li a {\n    text-decoration: none;\n    color: #636363;\n}\n\n.breadcrumb li a:hover {\n    color: #4a7c59;\n    text-decoration: underline;\n}\n\n.breadcrumb li::after {\n    content: '>';\n    margin-left: 5px;\n    font-size: 12px;\n    color: #a0a0a0; /* 흐린 색 */\n}\n\n.breadcrumb li:last-child::after {\n    content: '';\n}\n\n.breadcrumb-item.active {\n    background: none !important;\n    border: none !important;\n    padding: 0;\n    font-weight: bold; /* 마지막 요소 강조 */\n    color: #4a7c59; /* 마지막 요소 색상 변경 (선택 사항) */\n}\n\n@media screen and (max-width: 768px) {\n    .breadcrumb {\n        padding: 10px 20px;\n        font-size: 12px;\n    }\n\n    .breadcrumb li::after {\n        margin-left: 5px;\n        font-size: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
